<template>
  <div class="loginPage">
    <login-header ref="loginHeader" />
    <nuxt ref="page" />
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import LoginHeader from '~/containers/LoginHeader';

export default {
  name: 'Login',
  middleware: 'authRedirect',
  components: {
    LazyHydrate,
    LoginHeader,
  },
  created() {
    this.$auth.setAxiosHeader(this.$cookies.get('auth'));
  },
  head() {
    return this.$nuxtI18nHead({ addSeoAttributes: true });
  },
};
</script>
